const main = '//handl.ai'
const cabinet = '//my.dbrain.io'
const utilsUrl = 'https://9jbmz5boxe.execute-api.eu-west-1.amazonaws.com'

const config = {
	api: {
		web: process.env.APP_ENV === 'staging'
			? 'https://web.st-api.dbrainio.com/api/v1'
			: 'https://web.api.dbrainio.com/api/v1',
		ico: 'https://ico.api.dbrainio.com/api/v1',

		// endpoint to normalize tasks points
		points: `${utilsUrl}/dev/clean-poly`,
		compare: `${utilsUrl}/dev/iou`,
	},

	outer: {
		index: main,
		form: `${main}/form`,
		product: `${main}/#product`,
		usecases: `${main}/#usecases`,
		labeling: `${main}/#labeling`,
		datascience: `${main}/#datascience`,

		signup: cabinet,
		getQuoute: `${main}/#form`,
	},

	social: {
		twitter: 'https://twitter.com/handldata',
		facebook: 'https://fb.me/handldata',
	},

	routes: {
		index: '/',
		live: {
			path: '/live',
			order: {
				label: {
					toolType: 'label',
					preset: 'label',
				},
				aabb: {
					toolType: 'aabb',
					preset: 'aabb',
				},
				segmentation: {
					toolType: 'segmentation',
					preset: 'segmentation',
				},
				ocr: {
					toolType: 'ocr',
					preset: 'ocr',
				},
				textcategorization: {
					toolType: 'textcategorization',
					preset: 'textcategorization',
				},
				// aabb_simple: {
				// 	toolType: 'aabb',
				// 	preset: 'aabb-simple',
				// },
				// segmentation_simple: {
				// 	toolType: 'segmentation',
				// 	preset: 'segmentation-simple',
				// },
			},
		},
		demo: {
			label: {
				path: '/classes',
				toolType: 'label',
				preset: 'label',
				name: 'Classes',
			},
			aabb: {
				path: '/bounding-boxes',
				toolType: 'aabb',
				preset: 'aabb',
				name: 'Bounding boxes',
			},
			segmentation: {
				path: '/polygons',
				toolType: 'segmentation',
				preset: 'segmentation',
				name: 'Polygons',
			},
			ocr: {
				path: '/text-input',
				toolType: 'ocr',
				preset: 'ocr',
				name: 'Text input',
			},
			textcategorization: {
				path: '/text-segmentation',
				toolType: 'textcategorization',
				preset: 'textcategorization',
				name: 'Text segmentation',
			},
			// aabb_simple: {
			// 	path: '/demo/aabb-simple',
			// 	toolType: 'aabb',
			// 	preset: 'aabb-simple',
			// },
			// segmentation_simple: {
			// 	path: '/demo/segmentation-simple',
			// 	toolType: 'segmentation',
			// 	preset: 'segmentation-simple',
			// },
		},
	},
}

export default config
